import { useCallback } from 'react';
import { useUserLoggedIn } from '~/modules/user';
import type { ProfessionalIdentity } from '../types';
import { useChatBoxes } from './use-chat-boxes';
import { useConversationCache } from './use-conversation-cache';

/**
 * Hook to open a chat with a professional.
 */
export function useProfessionalChat() {
    const { user, isLoggedIn } = useUserLoggedIn();
    const { openChatBox, setNewMessageRecipients } = useChatBoxes();
    const { getCachedConversationByParticipants } = useConversationCache();

    const startProfessionalChat = useCallback(
        (professional: ProfessionalIdentity) => {
            const cached = getCachedConversationByParticipants(
                isLoggedIn ? user.ID : 0,
                [],
                [professional.ID],
            );
            if (cached) {
                openChatBox(Number(cached.ID), null);
                return;
            }
            setNewMessageRecipients([professional]);
            openChatBox(0, null);
        },
        [
            isLoggedIn,
            user.ID,
            openChatBox,
            setNewMessageRecipients,
            getCachedConversationByParticipants,
        ],
    );

    return { startProfessionalChat };
}
